import { c as _c } from "react/compiler-runtime";
import { useDeleteSearchHistoryMutation } from '@/Redux/apis/auth';
import React, { useEffect, useState } from 'react';
import { GoSearch } from 'react-icons/go';
import { toast } from 'react-toastify';
import { getSearchSuggestionLabel } from '@/utils/searchSuggestionDisplay';
import SearchSuggestionSubtitle from './SearchSuggestionSubtitle';
const SearchHistoryItem = t0 => {
  const $ = _c(61);
  const {
    search,
    type,
    handleClick,
    clickLoading,
    isClickLoading,
    clickedItemId
  } = t0;
  const [isLoading, setLoading] = useState(false);
  const highestPhase = type === "history" ? search?.clickedProduct?.highestPhase : search?.highestPhase;
  const [deleteHistory, deleteResponse] = useDeleteSearchHistoryMutation();
  let t1;
  if ($[0] !== deleteResponse.error || $[1] !== deleteResponse.isError || $[2] !== deleteResponse.isLoading || $[3] !== deleteResponse.isSuccess) {
    t1 = () => {
      if (deleteResponse.isLoading) {
        setLoading(true);
      } else {
        if (deleteResponse.isSuccess) {
          setLoading(false);
        } else {
          if (deleteResponse.isError) {
            toast.error(deleteResponse.error);
            setLoading(false);
          } else {
            setLoading(false);
          }
        }
      }
    };
    $[0] = deleteResponse.error;
    $[1] = deleteResponse.isError;
    $[2] = deleteResponse.isLoading;
    $[3] = deleteResponse.isSuccess;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== deleteResponse) {
    t2 = [deleteResponse];
    $[5] = deleteResponse;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  useEffect(t1, t2);
  let t3;
  if ($[7] !== clickLoading || $[8] !== handleClick || $[9] !== search || $[10] !== type) {
    t3 = () => {
      clickLoading(true);
      handleClick(search, type);
    };
    $[7] = clickLoading;
    $[8] = handleClick;
    $[9] = search;
    $[10] = type;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== clickedItemId || $[13] !== isClickLoading || $[14] !== search.clickedProduct?.productId || $[15] !== search.id || $[16] !== search.name || $[17] !== search.type || $[18] !== type) {
    t4 = isClickLoading && clickedItemId === (search.type === "Manufacturer" ? search.name : search.id || search?.clickedProduct?.productId) ? <div role="status" className="flex items-center justify-center flex-shrink-0"><svg aria-hidden="true" className="inline w-4 h-4 sm:w-5 sm:h-5 text-gray-200 animate-spin dark:text-gray-300 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" /><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" /></svg><span className="sr-only">Loading...</span></div> : <div className="flex-shrink-0">{type === "history" ? <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 sm:w-6 sm:h-6" viewBox="0 0 24 24" fill="none"><path d="M12 2.25C6.615 2.25 2.25 6.615 2.25 12C2.25 17.385 6.615 21.75 12 21.75C17.385 21.75 21.75 17.385 21.75 12C21.75 6.615 17.385 2.25 12 2.25ZM12 20.25C7.615 20.25 3.75 16.385 3.75 12C3.75 7.615 7.615 3.75 12 3.75C16.385 3.75 20.25 7.615 20.25 12C20.25 16.385 16.385 20.25 12 20.25ZM12.375 6.75H11.25V13.5L16.03 16.03L16.685 15.03L12.375 12.75V6.75Z" fill="#4B4B4B" /></svg> : <GoSearch className="w-5 h-5 sm:w-6 sm:h-6" stroke="4" />}</div>;
    $[12] = clickedItemId;
    $[13] = isClickLoading;
    $[14] = search.clickedProduct?.productId;
    $[15] = search.id;
    $[16] = search.name;
    $[17] = search.type;
    $[18] = type;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  let t5;
  if ($[20] !== search || $[21] !== type) {
    t5 = getSearchSuggestionLabel(search, type);
    $[20] = search;
    $[21] = type;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  let t6;
  if ($[23] !== search || $[24] !== type) {
    t6 = getSearchSuggestionLabel(search, type);
    $[23] = search;
    $[24] = type;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  let t7;
  if ($[26] !== t5 || $[27] !== t6) {
    t7 = <span className="min-w-0 truncate" title={t5}>{t6}</span>;
    $[26] = t5;
    $[27] = t6;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  let t8;
  if ($[29] !== highestPhase || $[30] !== search.type) {
    t8 = search.type === "pipeline" && <span className="shrink-0 inline-flex items-center rounded-full border border-amber-200 bg-amber-50 px-1.5 py-px text-[9px] sm:text-[10px] font-semibold uppercase tracking-wide text-amber-700">Pipeline{highestPhase && <><span className="mx-1 opacity-50">·</span>{String(highestPhase).replace(/^PHASE(\d)$/i, "Phase $1")}</>}</span>;
    $[29] = highestPhase;
    $[30] = search.type;
    $[31] = t8;
  } else {
    t8 = $[31];
  }
  let t9;
  if ($[32] !== t7 || $[33] !== t8) {
    t9 = <span className="truncate text-sm sm:text-[16px] font-medium font-poppins text-[#1F1F1F] flex items-center gap-1.5">{t7}{t8}</span>;
    $[32] = t7;
    $[33] = t8;
    $[34] = t9;
  } else {
    t9 = $[34];
  }
  let t10;
  if ($[35] !== search || $[36] !== type) {
    t10 = <SearchSuggestionSubtitle search={search} type={type} />;
    $[35] = search;
    $[36] = type;
    $[37] = t10;
  } else {
    t10 = $[37];
  }
  const t11 = search.type === "drug" || search.type === "device" || search.type === "otc" || search.type === "vaccine" ? "text-green-600 capitalize" : "capitalize text-amber-600";
  let t12;
  if ($[38] !== search.type || $[39] !== t11) {
    t12 = <span className="flex gap-1 text-[10px] sm:text-xs font-medium">in <p className={t11}>{search.type}</p></span>;
    $[38] = search.type;
    $[39] = t11;
    $[40] = t12;
  } else {
    t12 = $[40];
  }
  let t13;
  if ($[41] !== t10 || $[42] !== t12 || $[43] !== t9) {
    t13 = <div className="flex flex-col min-w-0 flex-1">{t9}{t10}{t12}</div>;
    $[41] = t10;
    $[42] = t12;
    $[43] = t9;
    $[44] = t13;
  } else {
    t13 = $[44];
  }
  let t14;
  if ($[45] !== t13 || $[46] !== t3 || $[47] !== t4) {
    t14 = <div onClick={t3} className="flex gap-1.5 sm:gap-2 flex-1 p-1.5 sm:p-2 min-w-0">{t4}{t13}</div>;
    $[45] = t13;
    $[46] = t3;
    $[47] = t4;
    $[48] = t14;
  } else {
    t14 = $[48];
  }
  let t15;
  if ($[49] !== deleteHistory || $[50] !== isLoading || $[51] !== search._id || $[52] !== type) {
    t15 = type === "history" && !isLoading && <button onClick={() => deleteHistory(search._id)} className="px-1.5 sm:px-2 text-xs sm:text-[14px] font-medium font-poppins text-[#F0142F] flex-shrink-0">Delete</button>;
    $[49] = deleteHistory;
    $[50] = isLoading;
    $[51] = search._id;
    $[52] = type;
    $[53] = t15;
  } else {
    t15 = $[53];
  }
  let t16;
  if ($[54] !== isLoading || $[55] !== type) {
    t16 = type === "history" && isLoading && <div role="status" className="px-1.5 sm:px-2 flex-shrink-0"><svg aria-hidden="true" className="inline w-4 h-4 text-gray-200 animate-spin dark:text-gray-300 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" /><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" /></svg><span className="sr-only">Loading...</span></div>;
    $[54] = isLoading;
    $[55] = type;
    $[56] = t16;
  } else {
    t16 = $[56];
  }
  let t17;
  if ($[57] !== t14 || $[58] !== t15 || $[59] !== t16) {
    t17 = <li className="w-full flex justify-between items-center hover:bg-gray-100 cursor-pointer">{t14}{t15}{t16}</li>;
    $[57] = t14;
    $[58] = t15;
    $[59] = t16;
    $[60] = t17;
  } else {
    t17 = $[60];
  }
  return t17;
};
export default SearchHistoryItem;